var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerDetailsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2183,
    height: 270,
    viewBox: "0 0 2183 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.406 43.2117L168.066 0.201172H102.891L162.298 53.0639L216.406 43.2117Z",
    fill: "#AA2500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.333 250.297L16 122V182.495L111.03 270H376.601L398 250.297H155.333Z",
    fill: "#754B27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 32.3446C52 25.9313 57.1778 20.7211 63.591 20.6811L2367.76 6.32024C2377.17 6.26163 2382.77 16.7852 2377.47 24.5549L2258.47 199.061C2256.29 202.263 2252.66 204.171 2248.79 204.154L63.6114 194.341C57.1903 194.312 52 189.099 52 182.678V32.3446Z",
    fill: "#213375"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 27.1799C37 23.3149 40.1332 20.1816 43.9982 20.1816L2333.76 20.1816C2338.94 20.1816 2342.32 25.6188 2340.04 30.2691L2229.84 254.273C2228.66 256.666 2226.22 258.182 2223.56 258.182H43.9982C40.1332 258.182 37 255.048 37 251.183V27.1799Z",
    fill: "url(#paint0_linear_16435_13237)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.648 0L16.3516 77.6669V137L168.577 0H102.648Z",
    fill: "#E07E27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9009 68.6523L62.2042 93.9676L16 137.152V77.5871L25.9009 68.6523Z",
    fill: "#FFDA00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.605 41.0996L91.3583 67.904L62.2056 93.9637L25.9023 68.6485L55.605 41.0996Z",
    fill: "#F58220"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.108 15.7852L98.5094 61.2036L90.8087 67.9047L55.6055 41.1004L83.108 15.7852Z",
    fill: "#D9166F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.159 0.150391L112.811 47.8026L98.5093 61.2047L82.0078 16.5308L100.159 0.150391Z",
    fill: "#50B848"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.707 0.150391L131.509 31.4221L112.807 47.8026L100.156 0.150391H111.707Z",
    fill: "#374EA2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.859 0.150391L148.56 15.0417L129.859 32.9113L111.707 0.150391H129.859Z",
    fill: "#DA2128"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16435_13237",
    x1: 37,
    y1: 139.182,
    x2: 2270.98,
    y2: 139.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216182
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203376"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerDetailsBg);
export default __webpack_public_path__ + "static/media/playerDetailsBg.53f89d97ab9e30d653cec340c4b1470a.svg";
export { ForwardRef as ReactComponent };